import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-mt-3 tw-overflow-x-auto tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur" }
const _hoisted_3 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700" }
const _hoisted_4 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_5 = { class: "tw-px-4 tw-py-3 tw-whitespace-pre-wrap" }
const _hoisted_6 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap tw-text-slate-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Logs", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              class: "tw-px-4 tw-py-3"
            }, "Activity"),
            _createElementVNode("th", {
              scope: "col",
              class: "tw-px-4 tw-py-3"
            }, "Date")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, logsIdx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: logsIdx,
              class: "hover:tw-bg-slate-50/60"
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(log.log), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatDatetime(log.date)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}